import * as React from "react";
import styled from "@emotion/styled";
import { ImLock } from "@react-icons/all-files/im/ImLock";
import Text from "../global/Text";
import { designTokens, easelFontFamily } from "../../helpers/constants";
import "./ContentViolationBanner.scss";

export interface ContentViolationBannerProps {
  // href for the contact us link in the message
  contactUsHref: string;
}

export const CONTENT_VIOLATION_TITLE = "Removed";
export const CONTENT_VIOLATION_CONTENT_US = "Contact Us";

export const CONTENT_VIOLATION_BODY =
  "This resource has been removed from the site. We apologize for any inconvenience. If you have any questions, please";

export const ContentViolationBanner: React.FC<ContentViolationBannerProps> = ({
  contactUsHref,
}) => {
  return (
    <Wrapper>
      <WrapperRow>
        <ImLock />
        <Text>{` ${CONTENT_VIOLATION_TITLE}`}</Text>
      </WrapperRow>
      <Space />
      <WrapperRow>
        <Text>
          {`${CONTENT_VIOLATION_BODY} `}
          <a className="ContentViolationBanner__textColor" href={contactUsHref}>
            {CONTENT_VIOLATION_CONTENT_US}
          </a>
          .
        </Text>
      </WrapperRow>
    </Wrapper>
  );
};

const WrapperRow = styled.div({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "pre-wrap",
});

const Space = styled.div({
  marginBottom: designTokens["ds-space-x"],
});

const Wrapper = styled.div({
  padding: designTokens["ds-space-2x"],
  fontFamily: easelFontFamily,
  fontSize: "0.8125rem",
  background: designTokens["ds-color-gold-100"],
  display: "flex",
  flexDirection: "column",
});
